import React from 'react'
const RightIcon = ({ className = "" }) => {
  return (
   <>
    <svg
      width="3.698975"
      height="6.337402"
      viewBox="0 0 3.69897 6.3374"
      fill="none"
      className={className}
    >
      <path
        id="Stroke 1"
        d="M0.5 5.83L3.16 3.16L0.5 0.5"
        stroke="currentColor"
        strokeOpacity="1.000000"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
    </svg></>
  );
};

export default RightIcon;
